import ready from "./ready";

ready(function() {
	const $main = document.querySelector('.c-main')
	const $mainLogo = document.querySelector('.js-main-logo')
	const $aside = document.querySelector('.c-aside')
	
	function placeLogo() {
		$mainLogo.style.position = 'fixed'
		$mainLogo.style.paddingTop = ''
		$mainLogo.style.right = '36px'
		$mainLogo.style.bottom = '36px'
		console.log($mainLogo.offsetTop, $main.offsetTop + $main.offsetHeight);
		if ($mainLogo.offsetTop < $main.offsetTop + $main.offsetHeight) {
			$mainLogo.style.position = ''
			$mainLogo.style.paddingTop = '24px'
		}
	}
	
	if ($mainLogo) {
		window.addEventListener('load', placeLogo)
		window.addEventListener('resize', placeLogo)
		placeLogo()
	}
})